import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { QuizsDetailsComponent } from './quiz-detail/quiz-detail.component';
import { QuizsComponent } from './quizs-list/quizs.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        component: QuizsComponent,
        data: {
          title: "Encuestas",
          breadcrumb: "Encuestas"
        }
      },
      {
        path: 'show/:id',
        component: QuizsDetailsComponent,
        data: {
          title: "Detalle de encuesta",
          breadcrumb: "Detalle de encuesta"
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class QuizsRoutingModule { }